import { Skeleton } from "@mui/material";

export const LoadingChip = () => {
  return (
    <div className="flex flex-col gap-.5 items-center justify-center w-fit">
      <Skeleton
        variant="rectangular"
        height={32}
        width={110}
        className="rounded-2xl"
      />
      <Skeleton
        variant="rectangular"
        height={10.5}
        width={120}
        className="mt-2"
      />
    </div>
  );
};

export default LoadingChip;
